import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Tabs, message } from 'antd';

import NotFound from 'pages/common/errors/NotFound';
import AuctionList from './components/AuctionList';

import { redirectToLoginPage } from 'utils';
import useAppSelector from 'hooks/useAppSelector';
import useNavigateToPrev from 'hooks/useNavigateToPrev';
import CenteredSpinner from 'pages/common/components/CenteredSpinner';

import styles from './SellerPage.module.css';
import EditSellerInfoForm from './components/EditSellerInfoForm';
import Title from 'pages/common/components/title/Title';

function SellerPage() {
  const navigate = useNavigate();
  const navigateToPrev = useNavigateToPrev();
  const { pathname } = useLocation();
  const { authenticated, loginUser } = useAppSelector((state) => state.user);
  const [initialLoading, setInitialLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!authenticated) {
      redirectToLoginPage(navigate);
    } else if (loginUser?.role !== 'seller') {
      navigateToPrev();
      message.error('판매자 권한이 없습니다.');
    } else {
      setInitialLoading(false);
    }
  }, [authenticated, loginUser?.role, navigate, navigateToPrev]);

  const auctionMenus = [
    {
      label: '경매 목록',
      key: '/seller/auctions',
      onClick: () => navigate('/seller/auctions'),
    },
    {
      label: '판매자 정보 관리',
      key: '/seller/info',
      onClick: () => navigate('/seller/info'),
    },
  ];

  let body = null;
  switch (pathname) {
    case '/seller/auctions':
      body = <AuctionList />;
      break;
    case '/seller/info':
      body = loginUser ? <EditSellerInfoForm user={loginUser} /> : <CenteredSpinner xCentered />;
      break;
  }

  return (
    <>
      {body ? (
        <>
          {initialLoading ? (
            <CenteredSpinner xCentered yCentered />
          ) : (
            <>
              <Title className={styles.title} level={1}>
                Seller Hub
              </Title>

              <Tabs centered activeKey={pathname} items={auctionMenus} />
              <div className={styles.body}>{body}</div>
            </>
          )}
        </>
      ) : (
        <NotFound />
      )}
    </>
  );
}

export default SellerPage;
